module.exports = __webpack_public_path__ + "./Lydia_pbw_892043126017028cb4e3e5b934b62437.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/sectionTalking/2024/Lydia_pbw.png
// module id = 617
// module chunks = 0